var LocationService = function() {
    return this;
};

//MUST OVERRIDE
LocationService.prototype.fetch = function fetch() {};

export default LocationService;
